import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from 'react-redux';
import { getStore } from './configureStore.js';
export const ReduxProvider = (props) => (_jsx(Provider, { store: getStore(), children: props.children }));
//# sourceMappingURL=ReduxProvider.js.map